import type { Canvas } from "fabric";
import type { LayerForType, LayerType } from "../types.ts";
import { getSpecificActiveLayers } from "../utils/layer.ts";
import { useCanvasEventsListener } from "./useCanvasEventsListener.ts";

export const useLayerSelectionEventListener = <T extends LayerType>({
  fabricCanvas,
  layerType,
  onLayerSelectionUpdate,
}: {
  fabricCanvas?: Canvas;
  layerType: T;
  onLayerSelectionUpdate: (layer: LayerForType<T>) => void;
}) => {
  useCanvasEventsListener({
    eventTypes: ["selection:created", "selection:updated", "selection:cleared"],
    onEvent: () => {
      const activeLayers = getSpecificActiveLayers({
        fabricCanvas,
        layerType,
      });

      if (activeLayers.length === 0) return;
      // FIXME: In case of multiple objects selected with different properties values, we should indicate to the user that the properties are not consistent.
      onLayerSelectionUpdate(activeLayers[0]);
    },
    canvas: fabricCanvas,
  });
};
